import get from 'lodash/get';


export default {
  state: {
    paymentMethods: []
  },
  getters: {
    getPaymentMethods(state) {
      return state.paymentMethods
    }
  },
  actions: {
    addPaymentMethod({ dispatch, commit }, data) {
      const { name, no, expiredMonth, expiredYear, csv, postalCode, country } = data

      const payload = {
        name,
        no,
        expiredMonth,
        expiredYear,
        csv,
        postalCode,
        country
      }

      return this.$api.post('/customer/paymentMethod', payload).then(res => {
        // response doesnt contain the payment info, so we need to refetch
        commit('SET_ADD_PAYMENT_METHOD_DIALOG', false)
        return dispatch('fetchPaymentMethods')
      }).catch(e => {
        dispatch('showApiErrorResponse', e)
      })
    },

    setAddPaymentMethodDialog({ commit }, val) {
      commit('SET_ADD_PAYMENT_METHOD_DIALOG', val)
    },

    fetchPaymentMethods({ dispatch, commit }) {
      return this.$api.get('/customer/paymentMethod').then(res => {
        commit('SET_PAYMENT_METHODS', res.data)
      }).catch(e => {
        dispatch('showApiErrorResponse', e)
      })
    },

    deletePaymentMethod({ dispatch }, id) {
      return this.$api.delete(`/customer/paymentmethod/${id}`).then(res => {
        // response doesnt contain the payment info, so we need to refetch
        dispatch('fetchPaymentMethods')
      }).catch(e => {
        dispatch('showApiErrorResponse', e)
      })
    }
  },
  mutations: {
    SET_PAYMENT_METHODS(state, methods) {
      state.paymentMethods = Array.isArray(methods)
        ? [ ...methods ]
        : []
    }
  }
}
